import request from '@/utils/request'

/** 海报类型：1 分享邀请 | 2 打卡 | 3 课程 | 4 拼团 */
export const POSTER_TYPE = {
  SHARE: 1,
  CHECKIN: 2,
  COURSE: 3,
  GROUP: 4
}

/**
 * 海报模板列表（GET /poster/index/poster_list，参数: type）
 * type: 1 分享 | 2 打卡 | 3 课程 | 4 拼团
 * 响应 data：poster_list / poster_image_list / poster_article_list
 */
export function fetchPosterList (type, params = {}) {
  return request({
    url: '/poster/index/poster_list',
    method: 'get',
    params: { type, ...params }
  })
}
